import React from 'react';
import { Modal } from 'antd';
import s from './s.module.less';

interface Props {
    show: boolean;
    onCancel: () => void;
    onOk: () => void;
}

const PermissionNotAllowModal = ({ show, onCancel, onOk }: Props) => {
    return (
        <Modal
            zIndex={99999}
            title="Permission is disabled in your browser"
            open={show}
            onCancel={() => {}}
            width={600}
            destroyOnClose
            closable={false}
            cancelButtonProps={{
                style: {
                    display: 'none',
                },
            }}
            footer={null}
        >
            <div className={s.wrap}>
                <div className={s.title}>
                    In order to enter the visit, please allow the camera and microphone permissions from your browser
                    settings.
                </div>
                <div className={s.content}>
                    <div className={s.label}>For Google Chrome:</div>
                    <ul>
                        <li>Click the lock icon 🔒 next to the website address in your browser’s address bar.</li>
                        <li>In the dropdown, find Camera and Microphone.</li>
                        <li>Select Allow from the dropdown menus next to Camera and Microphone.</li>
                        <li>Refresh the page.</li>
                    </ul>
                    <p>Alternatively:</p>
                    <ul>
                        <li>Go to chrome://settings/content/camera and chrome://settings/content/microphone.</li>
                        <li>Find this website in the list and set permissions to Allow.</li>
                        <li>Refresh the page.</li>
                    </ul>
                    <div className={s.label}>For Safari on macOS:</div>
                    <ul>
                        <li>Click Safari in the top menu bar and choose Settings for This Website....</li>
                        <li>In the popup, set Camera and Microphone to Allow or Ask.</li>
                        <li>Refresh the page.</li>
                    </ul>
                    <p>If you want to manage permissions globally:</p>
                    <ul>
                        <li>Go to Safari &gt; Settings... &gt; Websites.</li>
                        <li>Select Camera or Microphone in the sidebar.</li>
                        <li>Find this website in the list and change the permission to Allow.</li>
                    </ul>
                </div>
            </div>
        </Modal>
    );
};
export default PermissionNotAllowModal;
